/**
 * Format a number as USD with comma separators and 2 decimal places.
 * @param {number} value - The number to format
 * @param {object} [opts]
 * @param {boolean} [opts.sign] - Prepend +/- sign
 * @param {boolean} [opts.abs] - Use absolute value
 * @param {number} [opts.decimals=2] - Decimal places
 * @returns {string} e.g. "$1,234.56" or "+$1,234.56"
 */
export default function formatMoney(value, opts = {}) {
  const n = opts.abs ? Math.abs(Number(value) || 0) : (Number(value) || 0);
  const decimals = opts.decimals ?? 2;
  const formatted = n.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  const prefix = opts.sign ? (value >= 0 ? '+$' : '-$') : '$';
  // If sign mode and value is negative, we already used abs via toLocaleString
  if (opts.sign) {
    const absFormatted = Math.abs(n).toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
    return `${value >= 0 ? '+' : '-'}$${absFormatted}`;
  }
  return `$${formatted}`;
}
